import {Component, ElementRef, Input, NgZone, EventEmitter, OnInit, Output, ViewChild, OnChanges} from '@angular/core';
import {RoutesService} from '../../../core/routes/routes.service';
import {UtilsService} from '../../../core/utils/utils.service';

@Component({
  selector: 'app-supreme-point',
  templateUrl: './supreme-point.component.html',
  styleUrls: ['./supreme-point.component.scss']
})
export class SupremePointComponent implements OnInit, OnChanges {

  @Input() point: any;

  @Input() isStart: boolean;

  @Output() change = new EventEmitter();

  @ViewChild('autocomplete') autocompleteElementRef: ElementRef;

  constructor(private zone: NgZone, private utilsService: UtilsService, private routesService: RoutesService) { }

  ngOnInit() {

    const autocomplete = new google.maps.places.Autocomplete(this.autocompleteElementRef.nativeElement, {
      types: ['address'],
      componentRestrictions: {country: ['us']}
    });

    autocomplete.addListener('place_changed', () => {
      this.zone.run(() => {
        const place = autocomplete.getPlace();

        if (place.geometry === undefined || place.geometry === null) {
          this.isStart ? this.routesService.setStart(null) : this.routesService.setEnd(null);
        } else {
          const placeObj = {
            name: place.name,
            address: place.formatted_address,
            placeId: place.place_id,
            coords: [place.geometry.location.lng(), place.geometry.location.lat()]
          };
          this.isStart ? this.routesService.setStart(placeObj) : this.routesService.setEnd(placeObj);
        }
      });
    });
  }

  ngOnChanges() {
    if (!this.point) {
      this.autocompleteElementRef.nativeElement.value = '';
    } else {
      this.autocompleteElementRef.nativeElement.value = this.point.place.name;
    }
  }

  getPlaceholder() {
    return this.isStart ? 'Enter start point' : 'Enter end point';
  }

  getLegTravelTime(point) {
    return this.routesService.getLegTravelTime(point);
  }

  getLetter(point) {
    return this.routesService.getLetter(point);
  }

  getTimeDifference(point) {
    const nextPoint = this.routesService.getNextPoint(point);
    if (!nextPoint) {
      return null;
    }
    return this.routesService.getTimeDifference(nextPoint);
  }

  getFormattedTimeDifference(point) {
    const nextPoint = this.routesService.getNextPoint(point);
    if (!nextPoint) {
      return null;
    }
    const difference = this.routesService.getTimeDifference(nextPoint);
    const timeStr = this.utilsService.getHrsMinFromMinutes(Math.abs(difference));
    return difference > 0 ? `${timeStr} early` : `${timeStr} late`;
  }

  setTime(time) {
    this.point.time = time;
    this.change.next();
  }

}



// WEBPACK FOOTER //
// ./client/app/components/routes/supreme-point/supreme-point.component.ts